import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

function Groupedbarchart({ video_trending, filter }) {
    const { t } = useTranslation();
    const [groupedBarChartData, setGroupedBarChartData] = useState(null);
    const [groupedBarChartOptions, setGroupedBarChartOptions] = useState(null);
    
    useEffect(() => {
        if (!video_trending) return;

        const dates = [...new Set(video_trending.map((d) => d.axis_x))];

        const videoData = dates.map((date) => {
            const match = video_trending.find((d) => d.axis_x === date && d.legend === "Videos");
            return match ? match.axis_y : 0;
        });

        const liveData = dates.map((date) => {
            const match = video_trending.find((d) => d.axis_x === date && d.legend === "Live Streaming");
            return match ? match.axis_y : 0;
        });

        setGroupedBarChartData({
            labels: dates,
            datasets: [
                {
                    label: "Videos",
                    data: videoData,
                    backgroundColor: "#E04ACB",
                    barPercentage: 0.5,
                    categoryPercentage: 0.5,
                },
                {
                    label: "Live Streaming",
                    data: liveData,
                    backgroundColor: "#4F70FD",
                    barPercentage: 0.5,
                    categoryPercentage: 0.5,
                },
            ],
        });

        setGroupedBarChartOptions({
            responsive: true,
            plugins: {
                legend: {
                    position: "bottom",
                    labels: {
                        usePointStyle: true,
                        pointStyle: "circle",
                        boxWidth: 10,
                        boxHeight: 10,
                    },
                },
                tooltip: {
                    mode: "index",
                    intersect: false,
                },
                datalabels: { display: false },
                title: {
                    display: true,
                    text: `${t("Daily Video and Live Streaming Trends")} (${(filter.dateRange || "30") + " days"})`,
                },
            },
            scales: {
                x: {
                    stacked: false,
                    ticks: {
                        maxRotation: 45,
                        minRotation: 45,
                    },
                },
                y: {
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "frequency",
                    },
                },
            },
        });
    }, [video_trending, filter, t]);

    return (
        <Fragment>
            {groupedBarChartData && groupedBarChartOptions && (
                <Bar data={groupedBarChartData} options={groupedBarChartOptions} />
            )}
        </Fragment>
    );
}

const mapStateToProps = state => ({
});
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Groupedbarchart);